<template>
  <div class="inner">
    <inner-top :tabIndex="1"></inner-top>
    <!-- 考勤汇总 -->
    <div>
      <div class="inner_con">
        <div class="inner_search">
          <a-form
            layout="inline"
            :labelCol="{ lg: { span: 5 } }"
            :wrapperCol="{ lg: { span: 18 } }"
            labelAlign="left"
          >
            <div class="ulrow_list" style="width:100%">
              <a-form-item label="考勤时间" class="w100">
                <div>
                  <a-date-picker
                    @change="changeDate"
                    format="YYYY-MM-DD"
                    :disabled-date="collectDisabledEndDate"
                    v-model="collectStartDate"
                  />
                  <span class="date-text">到</span>
                  <a-date-picker
                    @change="changeDate"
                    format="YYYY-MM-DD"
                    :disabled-date="collectDisabledDate"
                    v-model="collectEndDate"
                  />
                </div>
              </a-form-item>
              <div
                class="date-tips pl78"
                :class="{ 'date-err': collectDays > 185 }"
              >
                单次查询日期的最长跨度为6个月
              </div>
            </div>
            <!-- 高级选项 -->
            <div class="option" v-show="isTab1Advanced">
              <div class="ulrow pl78">
                <div class="ulrow_list">
                  <a-form-item label="考勤老师" class="w100">
                    <a-select
                      allowClear
                      show-search
                      placeholder="请选择"
                      :not-found-content="fetching ? undefined : null"
                      v-model="collectParams.teacherName"
                      @dropdownVisibleChange="
                        dropdownVisibleChange($event, 'teacherNameList')
                      "
                    >
                      <a-spin
                        v-if="fetching"
                        slot="notFoundContent"
                        size="small"
                      />
                      <a-select-option
                        v-for="(item, index) in teacherNameList"
                        :value="item"
                        :key="index"
                        >{{ item }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </div>

                <div class="ulrow_list">
                  <a-form-item label="手机号" class="w100">
                    <a-input
                      class="form-cell"
                      type="number"
                      placeholder="请输入"
                      v-model="collectParams.teacherMobile"
                    ></a-input>
                  </a-form-item>
                </div>
              </div>
            </div>
            <div class="search-oper pl78 w100">
              <a-button type="primary" @click="queryCollectList">查询</a-button>
              <a class="advanced-option" @click="tab1Advanced"
                ><span v-show="!isTab1Advanced">查看</span
                ><span v-show="isTab1Advanced">隐藏</span>高级选项</a
              >

              <div class="download flex-items" v-if="collectTableData.length">
                <a-dropdown style="margin-right:30px">
                  <a class="download"> 按月导出<a-icon type="down" /> </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      v-for="(item, index) in monthList"
                      :key="index"
                    >
                      <a @click="exportMonth(item.date)" href="javascript:;">{{
                        item.title
                      }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <a
                  class="download"
                  :class="downLoading ? 'disabled' : ''"
                  @click="!downLoading ? collectExportOrder() : ''"
                >
                  <img v-if="!downLoading" src="/order/exportOrder_icon.png" />
                  {{ downLoading ? '导出中...' : 'Excel导出' }}
                </a>
              </div>
            </div>
          </a-form>
        </div>

        <a-table
          style="margin-top: 24px"
          :columns="columns1"
          :data-source="collectTableData"
          @change="onChangeCollect"
          :pagination="paginationCollect"
          :rowKey="getRowKey"
        >
          <span slot="teacherGander" slot-scope="text">{{
            text | gender
          }}</span>
          <span
            slot="action"
            slot-scope="text, record"
            @click="goDetail(record)"
            ><a>详情</a></span
          >
        </a-table>
      </div>
    </div>


    <a-spin
      class="fix-spin"
      :spinning="downLoading"
      tip="下载中，请勿操作..."
    />
  </div>
</template>

<script>
import moment from 'moment'
import {
  getSelectList,
  getCollectList,
  exportByMonth,
} from '../../api/report'
import CSchoolSelect from '../../components/CSchoolSelect'
import innerTop from './components/innerTop.vue'
import { downloadExcelFile } from '../../utils'
import Vue from 'vue'
import dayjs from 'dayjs'
export default {
  name: 'teacherAttend',
  data() {
    return {
      // 考勤汇总分页
      paginationCollect: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      fetching: false,
      columns1: [
        {
          title: '考勤老师',
          dataIndex: 'teacherName',
        },
        {
          title: '性别',
          dataIndex: 'teacherGander',
          scopedSlots: { customRender: 'teacherGander' },
        },
        {
          title: '手机号',
          dataIndex: 'teacherMobile',
        },
        {
          title: '老师来源',
          dataIndex: 'teacherOffering',
        },
        {
          title: '来源名称',
          dataIndex: 'teacherOfferingName',
        },
        {
          title: '正常考勤次数',
          dataIndex: 'normalAttendance',
        },
        {
          title: '异常考勤次数',
          dataIndex: 'abnormalAttendance',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ], // 考勤汇总
      statusClassName: ['', 'success', 'warning', 'disabled', ''],
      checkStatusText: ['待签到', '正常', '请假', '未签到', '其他'],
      isTab1Advanced: false, // 考勤汇总高级选项
      schoolList: [],
      collectStartDate: '', // 考勤汇总开始时间
      collectEndDate: '', // 考勤汇总结束时间
      collectDays: '', // 考勤汇总相差月数
      collectParams: {
        currentPage: 1,
        startTime: '',
        endTime: '',
        teacherName: undefined,
        teacherId: undefined,
        teacherMobile: undefined,
        teacherOffering: undefined,
        teacherOfferingName: undefined,
        bureauId: undefined,
        teacherOffering: 1,
        index: undefined,
      }, // 考勤汇总
      teacherOfferingIndex: undefined,
      teacherOfferingChoose: undefined, // 老师来源回显
      tableLoading: true,
      downLoading: false,
      collectTableData: [], // 考勤汇总
      // tableData: [], // 考勤明细
      classNameList: [], // 班级名称
      courseNameList: [], // 课程名称
      lessonNameList: [], // 课节名称
      schoolNameList: [], // 学校名称
      serviceProviderList: [], // 服务学校
      teacherOfferingList: [
        { id: 1, name: '学校' },
        { id: 2, name: '课程提供方' },
      ], // 老师来源下拉数据
      teacherNameList: [], // 老师名称
      imgUrlList: [], // 异常图片
      showImg: false, // 异常图片是否显示
      confirmLoading: false,
      monthList: [],
      teacherOfferingNameList: [],
    }
    // bureauId
  },
  components: {
    CSchoolSelect,
    innerTop,
  },
  methods: {
    collectExportOrder() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          if (_this.collectStartDate == '' || _this.collectEndDate == '') {
            _this.$message.error('请选择日期')
        return
      }
      _this.downLoading = true
      let fileName =
        '考勤汇总' +
        moment(_this.collectStartDate).format('YYYY年M月D日') +
        '-' +
        moment(_this.collectEndDate).format('YYYY年M月D日') +
        '.xlsx'
      downloadExcelFile(
        '/api/pcWeb/report/export',
        fileName,
        _this.collectParams
      ).then(() => {
        _this.downLoading = false
      })
        },
      })
    },
    // 考勤汇总详情
    goDetail(info) {
      let xhrParams = {
        currentPage: 1,
        pageSize: 10,
        teacherId: info.teacherId,
        startAttendDate: moment(this.collectStartDate).format('YYYY-MM-DD'),
        endAttendDate: moment(this.collectEndDate).format('YYYY-MM-DD'),
        teacherName: info.teacherName,
        mobile: info.teacherMobile,
        courseName: undefined,
        courseType: undefined,
        className: undefined,
        lessonName: undefined,
        schoolName: undefined,
        checkinStatus: undefined,
        serviceProvider: undefined,
        sourceType: undefined,
        teacherOffering: this.collectParams.teacherOffering,
        teacherOfferingName: info.teacherOfferingName,
      }
      this.$router.push({
        name: 'workDetail',
        params: {
          attendStartDate: this.collectStartDate,
          attendEndDate: this.collectEndDate,
          go: true,
          xhrParams,
        },
      })
      // this.getListData(this.xhrParams)
    },
    // 选择日期
    changeDate(event) {
      if (this.collectStartDate == null) {
        this.collectStartDate = ''
        this.collectParams.startTime = ''
        return
      } else if (this.collectEndDate == null) {
        this.collectEndDate = ''
        this.collectParams.endTime = ''
        return
      }

      this.collectDays = Math.abs(
        moment(this.collectEndDate).diff(moment(this.collectStartDate), 'days')
      )
      this.collectParams.startTime = moment(this.collectStartDate).format(
        'YYYY-MM-DD'
      )
      this.collectParams.endTime = moment(this.collectEndDate).format(
        'YYYY-MM-DD'
      )
    },
    // 控制选择日期范围
    collectDisabledDate(current) {
      return current && current < moment(this.collectStartDate)
    },
    // 控制选择日期范围
    collectDisabledEndDate(current) {
      return current && current > moment(this.collectEndDate)
    },
    // 考勤汇总高级选项
    tab1Advanced() {
      if (!this.isTab1Advanced) {
        this.isTab1Advanced = true
      } else {
        this.isTab1Advanced = false
      }
    },
    // 课程提供方下拉
    teacherOfferingChange(value) {
      if (value) {
        this.collectParams.teacherOffering = value;
      } else {
        this.collectParams.teacherOffering = undefined;
      }
      this.collectParams.teacherOfferingName = undefined;
      this.collectParams.sourceId = undefined;
      this.teacherOfferingIndex = undefined;
    },
    serviceChange(value) {
      if (!value) {
        this.collectParams.teacherOfferingName = undefined;
        this.collectParams.sourceId = undefined;
        return;
      }
      var provider = this.teacherOfferingNameList[value];
      if (provider.id == 0) {
        this.teacherOfferingChoose = undefined;
        this.collectParams.teacherOffering = undefined;
        this.collectParams.teacherOfferingName = undefined;
        this.collectParams.sourceId = undefined;
        return;
      }
      this.teacherOfferingChoose = provider.type;
      this.collectParams.teacherOffering = provider.type;
      this.collectParams.sourceId = provider.id;
      this.collectParams.teacherOfferingName = provider.name;
    },
    // 切换考勤汇总分页
    onChangeCollect(page) {
      this.collectParams.currentPage = page.current
      this.collectParams.pageSize = page.pageSize
      this.getCollectList(this.collectParams)
    },
    chooseListValue(index, list, key) {
      this.xhrParams[key] = this[list][index]
    },
    searchHandle(value, list) {
      return this.classNameList.filter((item) => item.includes(value))
    },
    // 搜索下拉框
    dropdownVisibleChange(type, list) {
      if (type && !this[list].length) {
        this.fetching = true
        setTimeout(() => {
          const key = list.charAt(0).toUpperCase() + list.slice(1)
          this[list] = [...this[`cache${key}`]]
          this.fetching = false
        }, 200)
      }
    },

    // 查询考勤汇总
   async queryCollectList() {
    let result =  await this.$store.dispatch('getUserInfo')
    this.collectParams.teacherOfferingName = result.schoolName 
      this.collectParams.bureauId = Vue.ls.get('bureauId')
      this.monthList = []
      if (this.collectDays > 185) {
        this.$message.error('单次查询日期的最长跨度为6个月')
        return
      } else if (this.collectStartDate == '' || this.collectEndDate == '') {
        this.$message.error('请输入日期')
        return
      }
      this.collectParams.currentPage = 1
      this.collectParams.pageSize = 10
      this.getCollectList(this.collectParams)
      this.paginationCollect.current = 1
      this.paginationCollect.pageSize = 10
      let a = (moment(this.collectEndDate).year()-moment(this.collectStartDate).year())*12
        +moment(this.collectEndDate).month()-moment(this.collectStartDate).month()

      for (let i = 0; i <= a; i++) {
        let month = moment(this.collectStartDate).add(i,'months')
        this.monthList.push({
          title: month.format('MM[月]'),
          date: month.format('YYYY-MM'),
        })
      }
    },
    //按月导出
    exportMonth(date) {
      let params = { ...this.collectParams, month: date }
      let fileName = '考勤汇总' + date + '.xlsx'
      exportByMonth(params).then((res) => {
        window.open(res.targetUrl, 'export')
      })
    },
    // 切换考勤汇总分页
    changePageCollect(page) {
      this.paginationCollect.current = page
    },

    // 考勤汇总
    async getCollectList(params) {
      this.tableLoading = true
      const data = await getCollectList(params).finally(() => {
        this.tableLoading = false
      })
      this.collectTableData = data.data.records
      this.paginationCollect.total = data.data.total
      this.paginationCollect.current = data.data.current
      this.paginationCollect.pageSize = data.data.size
    },

    // 下拉框数据
    async getSelectList(numbers) {
      const res = await getSelectList(numbers)
      this.classNameList = res.data.className
      this.courseNameList = res.data.courseName
      this.lessonNameList = res.data.lessonName
      this.schoolNameList = res.data.schoolName
      this.serviceProviderList = res.data.serviceProvider
      this.teacherOfferingNameList = res.data.teacherOfferingName
      this.teacherNameList = res.data.teacherName
    },
    getRowKey(record, index) {
      return index;
    },
  },

  created() {
    let numbers = Vue.ls.get('schoolId')
    this.collectStartDate = moment(dayjs().subtract(1, 'month').format('YYYY-MM-DD'))
    this.collectParams.startTime = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
    this.collectEndDate = moment(dayjs())
    this.collectParams.endTime = dayjs().format('YYYY-MM-DD')
    // this.getListData() // 获取考勤明细
    // this.getCollectList() // 获取考勤汇总
    this.getSelectList(numbers) // 获取下拉框数据
  }
}
</script>

<style lang="less" scoped>
.w100 {
  width: 100%;
}
.pl78 {
  padding-left: 78px;
}
.mb15 {
  margin-bottom: 15px;
}
/deep/ .ant-form-item-label-left {
  width: 78px;
}

.inner {
  width: calc(100% - 40px);
  margin: 20px auto;
  background: white;
  border-radius: 8px;
}
.inner_top {
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  line-height: 40px;
  margin-bottom: 20px;
  div {
    font-size: 14px;
    color: #909399;
    display: inline-block;
    width: 90px;
    text-align: center;
    border-bottom: 2px solid white;
  }
  .item-active {
    color: #37C894;
    border-bottom: 2px solid #37C894;
  }
}
.inner_title {
  color: rgba(16, 16, 16, 100);
  font-size: 20px;
  padding-bottom: 20px;
}
.inner_con {
  background: #fff;
  padding: 20px;
}
// 选择日期提示文字
.date-tips {
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  margin-top: 8px;
}
// 选择日期超出范围
.date-err {
  color: #ff0000;
}
// 选择日期之间文字
.date-text {
  margin: 0 16px;
}
.ulrow {
  display: flex;
  flex-wrap: wrap;
}
.ulrow_list {
  width: calc(100% / 4);
  margin-bottom: 15px;
}
.ulrow_list_tuwo {
  width: 50%;
  text-align: right;
}
.inner_con h2 {
  font-size: 16px;
  font-weight: bold;
}

.search-oper {
  width: 100%;
  display: flex;
  align-items: center;
  .advanced-option {
    margin-left: 42px;
  }
}
.download {
  display: inline-block;
  // margin-left: 20px;
  margin-left: auto;
  text-decoration: none;
  color: #1890ff;
  position: relative;
  font-size: 14px;
}
.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}
.fix-spin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  padding-top: 50vh;
  color: #68CC2E;
}
::v-deep .ant-spin-dot-item {
  background-color: #68CC2E;
}

/deep/ .ant-modal-title {
  text-align: center;
  color: rgba(16, 16, 16, 100);
  font-size: 28px;
}

// 手机号输入
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

// 异常图片
.abnormal-img {
  div {
    margin-bottom: 33px;
  }
  .no-img {
    font-size: 18px;
    color: rgba(16, 16, 16, 100);
    text-align: center;
    margin-bottom: 0;
  }
  img {
    display: block;
    width: 321px;
    height: 205px;
    margin: 0 auto;
  }
}
</style>
